export const FONT_FAMILIES = {
  NOTO_SANS: 'Noto Sans',
  POPPINS: 'Poppins',
  INTER: 'Inter',
  ROBOTO: 'Roboto',
};

export default FONT_FAMILIES;
